{
  "version": 1,
  "asset_id": "d4a08fd5-c33f-4f33-990a-c12f26daf13a",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/d4a08fd5-c33f-4f33-990a-c12f26daf13a/bypass-revision-completed-pouch-en-320.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/d4a08fd5-c33f-4f33-990a-c12f26daf13a/bypass-revision-completed-pouch-en-320.webp",
  "original_filename": "bypass-revision-completed-pouch-en-320.webp",
  "size": 10276,
  "content_type": "image/webp",
  "created_at": "2026-10-05T22:12:47Z"
}
